module.exports = __webpack_public_path__ + "static/PlayStore-cbd62c770dcd33caada7927d6ab3f942.jpg";